interface SchemaOrgProps {
  type: "Organization" | "WebSite" | "WebPage" | "BreadcrumbList" | "Article" | "FAQPage";
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const schemas: Record<string, string> = {
    Organization: "https://schema.org/Organization",
    WebSite: "https://schema.org/WebSite",
    WebPage: "https://schema.org/WebPage",
    BreadcrumbList: "https://schema.org/BreadcrumbList",
    Article: "https://schema.org/Article",
    FAQPage: "https://schema.org/FAQPage",
  };

  const ldJson = {
    "@context": "https://schema.org",
    "@type": type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }}
    />
  );
}